"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _rcMenu = _interopRequireWildcard(require("rc-menu"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Menus');
var SIZES = {
  small: 140,
  medium: 220,
  large: 300
};

function Menus(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      items = _ref.items,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      triggerAction = _ref.triggerAction,
      size = _ref.size;
  var popupSize = SIZES[size];
  var classes = (0, _overrides.useClasses)(useStyles, classesProp, {
    popupSize: popupSize
  }); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Menus.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var menuProps = (0, _extends2.default)({
    mode: 'horizontal',
    className: classes.menu,
    triggerSubMenuAction: triggerAction
  }, override['rc-menu']);
  var subMenuProps = {
    title: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, icon && icon, title && title),
    popupClassName: classes.subMenu
  };
  var menuItemProps = {
    className: classes.menuItem
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClassName
  }, override.root), /*#__PURE__*/_react.default.createElement(_rcMenu.default, menuProps, /*#__PURE__*/_react.default.createElement(_rcMenu.SubMenu, subMenuProps, items && items.map(function (item, id) {
    return /*#__PURE__*/_react.default.createElement(_rcMenu.MenuItem, (0, _extends2.default)({
      key: id,
      itemIcon: item.icon,
      onClick: item.onClick
    }, menuItemProps), item.title);
  }))));
}

Menus.overrides = ['root', 'rc-menu'];
Menus.defaultProps = {
  triggerAction: 'click',
  size: 'large'
};
process.env.NODE_ENV !== "production" ? Menus.propTypes = {
  title: _propTypes.default.any,
  icon: _propTypes.default.object,
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.any,
    icon: _propTypes.default.object,
    onClick: _propTypes.default.func
  })),
  triggerAction: _propTypes.default.oneOf(['hover', 'click']),
  size: _propTypes.default.oneOf(['small', 'medium', 'large'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Menus);

exports.default = _default;